import styled from "styled-components";

export const StyledModalTextarea = styled.div`
	& textarea {
		width: 100%;
		min-height: ${(props) => (props.size === "small" ? "2rem" : "35rem")};

		resize: none;

		overflow-y: scroll;
	}

	& input {
		width: 100%;
	}

	& > div:not(.ck) {
		width: 100%;
		margin-top: 1.5rem;

		display: flex;
		justify-content: flex-end;
		align-items: center;

		& button:last-child {
			margin-left: 4.5rem;
		}
	}
`;
